export default {
    'delete-message-trainings': 'Are you sure you want to delete this trainings?'
}